import React from 'react';
import { Button, Typography, COLORS } from 'pvs-design-system';
import { Stack } from '@mui/material';

interface PaginationControlsProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({ page, totalPages, onPageChange }) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={2} sx={{ mt: 4, mb: 2 }}>
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        disabled={page === 1}
        onClick={() => onPageChange(Math.max(1, page - 1))}
      >
        &#8249; Previous
      </Button>
      <Typography variant="p-sm" style={{ color: COLORS.gray[400], fontSize: 12 }}>
        Page {page} of {totalPages}
      </Typography>
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        Next &#8250;
      </Button>
    </Stack>
  );
};

export default PaginationControls;
